module.exports = __webpack_public_path__ + "img/IMG_2024_L_Black_MockedUp.66d50cdc.jpg";